import { jsxs as l, jsx as o } from "react/jsx-runtime";
const c = (r) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M32 10c1.92 0 4.01.33 6.03.96 2.19.68 4.26 1.7 5.96 2.96 1.86 1.36 3.31 2.99 4.31 4.84 1.12 2.07 1.69 4.44 1.69 7.04 0 2.46-.98 5.45-2.9 8.89-1.68 3-4.05 6.27-7.05 9.71-3 3.45-6.03 6.39-8.09 8.28-2.02-1.82-5-4.66-7.96-8.03-3.01-3.42-5.39-6.68-7.07-9.7C14.98 31.46 14 28.39 14 25.8c0-5.14 2.01-9.19 5.98-12.05 1.71-1.23 3.71-2.19 5.94-2.84 2-.6 4.11-.91 6.08-.91Zm0-4c-8.96 0-22 5.41-22 19.8S32 58 32 58s22-18.31 22-32.2C54 11.91 40.96 6 32 6Z"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "m34.12 18.526-5.795 1.553 1.553 5.795 5.795-1.553-1.553-5.795Z"
        }
      )
    ]
  }
);
export {
  c as Location
};
